// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"b71ca195","247":"336a41a7","284":"2267be79","422":"883cbc77","484":"14fa780f","627":"c04060b9","768":"c391ef24","834":"b7c80e67","867":"7df66bd8","923":"90804aef","938":"950cf668"}[chunkId] + ".chunk.js";
};